<template>
  <div>
    <location />
    <div class="page wrap-1200 my-summary">
      <h3 class="my-subtitle">
        {{ $t("menu.membership.my_summary") }}
      </h3>
      <div class="my-summary-chart">
        <div class="d-flex align-items-center mb-3">
          <h4 class="my-summary-chart-title">
            {{ $t("title.membership.round_summary") }}
            <span class="ms-0 ms-sm-1 mt-2 mt-sm-0 text-subscript text-green">
              ({{ $t("text.common.18hole_finish") }}*)
            </span>
          </h4>
          <TermDefinition getname="score" />
        </div>
        <div class="chart" ref="chartWrapper">
          <GChart
            v-if="chartsData.data.length > 1"
            type="LineChart"
            :data="chartsData.data"
            :options="chartsData.summaryOptions"
            ref="chartSummary"
            class="chart-summary"

          />
          <div v-else class="text-center py-5" style="background-color: #fff">
            <p class="text-muted">{{ $t("text.common.no_data") }}</p>
          </div>
        </div>
      </div>
      <div class="my-summary-list">
        <div
          class="my-summary-item"
          @click="
            get_stats({
              chart_recent: 10,
              field: 'longest_drive',
              chart_title: $t('title.common.max_distance'),
              format: { suffix: 'm' },
            })
          "
        >
          <p class="tit">{{ $t("title.common.max_distance") }}</p>
          <p class="dsc">{{ summaryinfo.maxdriver | toFixed | suffix("m") }}</p>
        </div>
        <div
          class="my-summary-item"
          @click="
            get_stats({
              chart_recent: 10,
              field: 'avg_drive',
              chart_title: $t('title.common.avg_distance'),
              format: { suffix: 'm' },
            })
          "
        >
          <p class="tit">{{ $t("title.common.avg_distance") }}</p>
          <p class="dsc">{{ summaryinfo.avg_drive | toFixed | suffix("m") }}</p>
        </div>
        <div
          class="my-summary-item"
          @click="
            get_stats({
              chart_recent: 10,
              field: 'avg_score',
              chart_title: $t('title.common.avg_score'),
              format: { suffix: '' },
            })
          "
        >
          <p class="tit">{{ $t("title.common.avg_score") }}</p>
          <p class="dsc">{{ summaryinfo.avgscore | toFixed | suffix("") }}</p>
        </div>
        <div
          class="my-summary-item"
          @click="
            get_stats({
              chart_recent: 10,
              field: 'parsave',
              chart_title: $t('title.common.par_save_rate'),
              format: { suffix: '%' },
            })
          "
        >
          <p class="tit">{{ $t("title.common.par_save_rate") }}</p>
          <p class="dsc">{{ summaryinfo.parsave | toFixed | suffix("%") }}</p>
        </div>
        <div
          class="my-summary-item"
          @click="
            get_stats({
              chart_recent: 10,
              field: 'fairway_drive',
              chart_title: $t('text.common.fareway_hit'),
              format: { suffix: '%' },
            })
          "
        >
          <p class="tit">{{ $t("title.common.fareway_hit") }}</p>
          <p class="dsc">{{ summaryinfo.fairway | toFixed | suffix("%") }}</p>
        </div>
        <div
          class="my-summary-item"
          @click="
            get_stats({
              chart_recent: 10,
              field: 'greens',
              chart_title: $t('text.common.gir'),
              format: { suffix: '%' },
            })
          "
        >
          <p class="tit">{{ $t("title.common.gir") }}</p>
          <p class="dsc">{{ summaryinfo.greens | toFixed | suffix("%") }}</p>
        </div>
        <div
          class="my-summary-item"
          @click="
            get_stats({
              chart_recent: 10,
              field: 'avg_putt',
              chart_title: $t('title.common.avg_putts_distance'),
              format: { suffix: 'm' },
            })
          "
        >
          <p class="tit">{{ $t("title.common.avg_putts_distance") }}</p>
          <p class="dsc">
            {{ summaryinfo.avggreenhit | toFixed | suffix("m") }}
          </p>
        </div>
        <div
          class="my-summary-item"
          @click="
            get_stats({
              chart_recent: 10,
              field: 'handicap',
              chart_title: $t('title.common.x_handicap'),
              format: { suffix: '' },
            })
          "
        >
          <p class="tit">{{ $t("title.common.x_handicap") }}</p>
          <p class="dsc">{{ hc_au(summaryinfo.handicap_index) }}</p>
        </div>
        <div
          class="my-summary-item"
          @click="
            get_stats({
              chart_recent: 10,
              field: 'avg_putt',
              chart_title: $t('title.common.avg_putts_distance'),
              format: { suffix: 'm' },
            })
          "
        >
          <p class="tit">{{ $t("title.common.avg_scoring_par") }}</p>
          <p class="dsc">
            {{ summaryinfo.scoring_avg_to_par | toFixed | suffix("") }}
          </p>
        </div>
        <div
          class="my-summary-item"
          @click="
            get_stats({
              chart_recent: 10,
              field: 'best_score_to_par',
              chart_title: $t('title.common.best_scoring_par'),
              format: { suffix: '' },
            })
          "
        >
          <p class="tit">{{ $t("title.common.best_scoring_par") }}</p>
          <p class="dsc">
            {{ summaryinfo.best_score_to_par | toFixed | suffix("") }}
          </p>
        </div>
      </div>

      <div class="my-summary-badge">
        <h4 class="my-summary-badge-title">
          <span>{{ $t("title.common.my_badge") }}</span>
          <span class="label" v-if="newBadgeCount > 0"
            >NEW {{ newBadgeCount }}</span
          >
        </h4>
        <div class="swiper-area">
          <swiper :options="swiperOption">
            <swiper-slide
              v-for="(item, index) in badgeList"
              :key="index"
              class="swiper-list"
            >
              <div class="swiper-list-item">
                <div class="swiper-list-image">
                  <div
                    class="img-area"
                    :class="{ 'is-disabled': item.disabled }"
                  >
                    <div
                      class="image"
                      :style="{
                        backgroundImage: `url(/img/${item.badge}.svg)`,
                      }"
                    ></div>
                  </div>
                  <span class="label" v-if="item.new">NEW</span>
                </div>
                <div class="swiper-list-desc">
                  <p
                    class="title"
                    style="text-transform: capitalize;"
                    :class="{
                      'color-red': item.color === 'red',
                      'color-green': item.color === 'green',
                      'color-brown': item.color === 'brown',
                      'color-blue': item.color === 'blue',
                      'color-gold': item.color === 'gold',
                    }"
                  >
                    {{ item.name }}
                  </p>
                  <p class="date">{{item.regdate}}</p>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="20"
              viewBox="0 0 12 20"
              fill="none"
            >
              <path
                d="M10 -1.55175e-07L11.775 1.775L3.55002 10L11.775 18.225L10 20L2.47161e-05 10L10 -1.55175e-07Z"
                fill="#676D73"
              />
            </svg>
          </div>
          <div class="swiper-button-next">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="20"
              viewBox="0 0 12 20"
              fill="none"
            >
              <path
                d="M1.775 20L0 18.225L8.225 10L0 1.775L1.775 0L11.775 10L1.775 20Z"
                fill="#1C1B1F"
              />
            </svg>
          </div>
        </div>
        <div class="my-badge">
          <swiper :options="myBadgeswiperOption">
            <swiper-slide
              v-for="(item, index) in badgeList"
              :key="index"
              class="my-badge-list"
            >
              <div
                class="my-badge-item"
                :class="{ 'is-disabled': item.disabled }"
                @click="toast_xbadge_info(item)"
                :style="{
                  backgroundImage: `url('/img/${item.badge_mob}.svg')`,
                }"
              >
                <span class="new" v-if="item.new">N</span>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>

      <div class="my-summary-recent">
        <router-link :to="{ name: 'MyRounds' }">
          <h3 class="my-summary-recent-title d-flex align-items-center gap-1">
            <span>{{ $t("title.membership.recent_round") }}</span>
            <span class="material-icons-outlined">navigate_next</span>
          </h3>
        </router-link>
        <div class="my-summary-list none-hover">
          <div class="my-summary-item">
            <p class="tit">{{ $t("title.common.date") }}</p>
            <p class="dsc d-flex align-items-center gap-1">
              <template
                v-if="
                  recentplayinfo.timezone_date &&
                  recentplayinfo.timezone_date.timezone_private
                "
              >
                <dfn
                  class="time-zone-mark badge rounded-pill bg-orange"
                  title="Connect time"
                  >CT</dfn
                >
                <span>{{
                  recentplayinfo.timezone_date.timezone_private | dateformat
                }}</span>
              </template>
              <template
                v-else-if="
                  recentplayinfo.timezone_date &&
                  recentplayinfo.timezone_date.timezone_common
                "
              >
                <dfn
                  class="time-zone-mark badge rounded-pill bg-green"
                  title="Standard time"
                  >ST</dfn
                >
                <span>{{
                  recentplayinfo.timezone_date.timezone_common | dateformat
                }}</span>
              </template>
            </p>
          </div>
          <div class="my-summary-item">
            <p class="tit">{{ $t("title.common.course") }}</p>
            <p class="dsc">{{ recentplayinfo.coursename || "-" }}</p>
          </div>
          <div class="my-summary-item">
            <p class="tit">{{ $t("title.common.score") }}</p>
            <p class="dsc">
              {{ Math.sign(recentplayinfo.score) > 0 ? "+" : ""
              }}{{ recentplayinfo.score }}
            </p>
          </div>
          <div class="my-summary-item">
            <p class="tit">{{ $t("title.common.shot") }}</p>
            <p class="dsc">{{ recentplayinfo.shot || "-" }}</p>
          </div>
          <div class="my-summary-item">
            <p class="tit">{{ $t("title.common.max_distance") }}</p>
            <p class="dsc">
              {{
                recentplayinfo.maxdriver ? recentplayinfo.maxdriver + "m" : "-"
              }}
            </p>
          </div>
          <div class="my-summary-item">
            <p class="tit">{{ $t("title.common.avg_distance") }}</p>
            <p class="dsc">
              {{
                recentplayinfo.avgdriver ? recentplayinfo.avgdriver + "m" : "-"
              }}
            </p>
          </div>
          <div class="my-summary-item">
            <p class="tit">{{ $t("title.common.fareway_hit") }}</p>
            <p class="dsc">
              {{
                recentplayinfo.farewayrate
                  ? recentplayinfo.farewayrate + "%"
                  : "-"
              }}
            </p>
          </div>
          <div class="my-summary-item">
            <p class="tit">{{ $t("title.common.par_save_rate") }}</p>
            <p class="dsc">
              {{
                recentplayinfo.parsaverate
                  ? recentplayinfo.parsaverate + "%"
                  : "-"
              }}
            </p>
          </div>
          <div class="my-summary-item">
            <p class="tit">{{ $t("title.common.gir") }}</p>
            <p class="dsc">
              {{
                recentplayinfo.greenrate ? recentplayinfo.greenrate + "%" : "-"
              }}
            </p>
          </div>
          <div class="my-summary-item">
            <p class="tit">{{ $t("title.common.avg_putts_distance") }}</p>
            <p class="dsc">
              {{
                recentplayinfo.avggreenhit
                  ? recentplayinfo.avggreenhit + "m"
                  : "-"
              }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- modal-stats-chart -->
    <b-modal
      id="modal-stats-chart"
      ref="modal-stats-chart"
      size="lg"
      centered
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h3>{{ $t("text.common.comparative_analysis") }}</h3>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-stats-chart')"
        />
      </template>
      <div
        class="row row-cols-1 row-cols-lg-auto g-0 justify-content-between align-items-center"
      >
        <div class="col">
          <p class="modal-subtitle mb-lg-0">{{ searchData.chart_title }}</p>
        </div>
        <div class="col">
          <select v-model="searchData.chart_recent">
            <option value="" disabled>Recent</option>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
          </select>
        </div>
      </div>
      <div class="mt-4 p-3 border">
        <GChart
          v-if="chartsData.saleclubData.length > 1"
          ref="chartPopover"
          type="LineChart"
          :data="chartsData.saleclubData"
          :options="chartsData.saleclubtotalOptions"
          class="align-self-center w-100"
          @ready="onPopoverChartReady"
        />
        <div v-else class="text-center py-5">
          <p class="text-muted">{{ $t("text.common.no_data") }}</p>
        </div>
      </div>
      <template #modal-footer>
        <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-stats-chart')"
        >
          {{ $t("button.common.close") }}
        </b-button>
      </template>
    </b-modal>

    <!-- modal-badge -->
    <b-modal
      id="modal-badge"
      ref="modal-badge"
      size="md"
      centered
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h3>{{ $t("title.common.player_badge") }}</h3>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="badgeClose(playerbadgeno)"
        />
      </template>
      <div
        class="row row-cols-1 row-cols-lg-auto g-0 justify-content-center align-items-center"
      >
        <div class="col align-center">
          <p class="modal-subtitle mb-lg-0 fs-24">Congratulations!</p>
          <badge v-if="badgeMove" />
          <div
            class="content"
            :class="{ 'is-move': badgeMove }"
            v-if="playerbadgeno"
          >
            <img :src="badgefilename | get_img" alt="badge_xgolf" />
            <p class="modal-subtitle mb-lg-0">
              {{ badgename }} {{ $t("text.common.player_badge_txt") }}
            </p>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.close')"
          @click="badgeClose(playerbadgeno)"
        >
          {{ $t("button.common.close") }}
        </b-button>
      </template>
    </b-modal>

    <!-- toast-xbadge-info -->
    <b-toast
      id="toast-xbadge-info"
      toaster="position-fixed top-50 start-50 translate-middle"
      body-class="pt-0 text-center"
      no-auto-hide
      solid
    >
      <template #toast-title>{{ $t("text.common.xbadge_info") }}</template>
      <div class="card justify-content-center my-3 p-4 bg-gray border-0">
        <div class="badge-full-img bg-pink-">
          <span
            class="material-icons avatar-active fw-bold"
            v-if="xbadge_info && xbadge_info.badge_pk == player_info.badge_fk"
            >done</span
          >
          <img :src="`/img/${badge_info}.svg`" />
        </div>
      </div>
      <p class="sub-title">{{ xbadge_info && xbadge_info.title }}</p>
      <p class="mb-2">{{ xbadge_info && xbadge_info.memo }}</p>
      <div class="btn-bottom-wrapper">
        <b-button
          size="sm"
          variant="outline-secondary"
          :aria-label="$t('button.common.close')"
          @click="$bvToast.hide('toast-xbadge-info')"
        >
          {{ $t("button.common.close") }}
        </b-button>
        <b-button
          v-if="
            xbadge_info &&
            playerbadge_list.find((v) => v.badge_fk == xbadge_info.badge_pk) &&
            xbadge_info.badge_pk !== player_info.badge_fk
          "
          size="sm"
          variant="secondary"
          :aria-label="$t('button.common.change')"
          @click="badge_chg(xbadge_info && xbadge_info.badge_pk)"
        >
          {{ $t("button.common.change") }}
        </b-button>
        <b-button
          v-if="
            xbadge_info &&
            playerbadge_list.find((v) => v.badge_fk == xbadge_info.badge_pk) &&
            xbadge_info.badge_pk == player_info.badge_fk
          "
          size="sm"
          variant="secondary"
          :aria-label="$t('button.common.remove')"
          @click="badge_remove()"
        >
          {{ $t("button.common.remove") }}
        </b-button>
      </div>
    </b-toast>
  </div>
</template>

<script>
import location from "@/components/Location";
import ax from "@/api/membership";
import "@/filter/common";
import TermDefinition from "@/components/TermDefinition";
import { GChart } from "vue-google-charts/legacy";
import badge from "@/components/lottie/badge.vue";
import { myMixin } from "@/mixin/myMixin";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "MySummary",
  components: {
    location,
    TermDefinition,
    GChart,
    badge,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      popoverLabelPoints: [],
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        breakpoints: {
          1024: { slidesPerView: 3, spaceBetween: 20 },
          1200: { slidesPerView: 4, spaceBetween: 24 },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      myBadgeswiperOption: {
        slidesPerView: 5,
        spaceBetween: 10,
      },
      searchData: {
        chart_recent: 30,
        field: "avg_score",
        chart_title: "",
        format: { suffix: "" },
      },
      summaryinfo: {},
      recentplayinfo: {},
      swinginfo: [],
      swingdata_yn: true,
      badgecnt: 0,
      badgeinfo: [],
      view_hide: null,
      xbadge_info: null,
      playerbadge_list: [],
      player_info: {},
      badge_info: "",
      playerbadgeno: 0,
      badgename: "",
      badgefilename: "",
      badgeseq: 0,
      badgeMove: false,
      chartsData: {
        // 메인 차트 데이터
        data: [["Round", "Group Avg Score", "Avg Score"]],
        summaryOptions: {
          focusTarget: "category",
          legend: { position: "bottom" }, // none → bottom
          chartArea: {
            height: "100%",
            width: "100%",
            top: 24,
            left: 50,
            right: 24,
            bottom: 67,
          },
          height: 330,
          width: "100%",
          pointsVisible: true,
          pointSize: 8,

          vAxis: {
            title: "Score",
            titleTextStyle: {
              color: "#ADB0B3",
              fontSize: 12,
              weight: 500,
              italic: false,
              family: "Roboto",
            },
            gridlines: { color: "#EDEDED", count: 5 },
          },
          hAxis: {
            // title 제거
            gridlines: { color: "#EDEDED" },
            baselineColor: "#EDEDED",
            textStyle: { color: "#333333", fontSize: 12, bold: true },
          },
          colors: ["#7987FF", "#F63"],
          curveType: "function",
          series: {
            0: { color: "#7987FF", lineWidth: 1, pointSize: 8 }, // Group Avg
            1: { color: "#F63", lineWidth: 1, pointSize: 8 }, // My Score
          },
          animation: { startup: true, duration: 1000, easing: "out" },
        },

        // 팝업 차트 데이터
        saleclubData: [],
        saleclubtotalOptions: {
          focusTarget: "category",
          legend: { position: "bottom" },
          chartArea: {
            height: "100%",
            width: "100%",
            top: 48,
            left: 35,
            right: 10,
            bottom: 48,
          },
          height: "100%",
          width: "100%",
          pointsVisible: true,
          pointSize: 4,
          vAxis: { format: { suffix: "" }, title: "" },
          hAxis: {
            textPosition: "OUT",
            slantedText: true,
          },
          colors: ["#7987FF", "#F63"],
          curveType: "function",
          series: {
            0: { color: "#7987FF", lineWidth: 1, pointSize: 4 }, // Group Avg
            1: { color: "#F63", lineWidth: 1, pointSize: 4 }, // My Score
          },
          animation: { startup: true, duration: 1000, easing: "out" },
        },
      },
      badgeList: [],
      badge_list: [],
      playerbadge_list: [],
    };
  },
  methods: {
    buildBadgeList(badge_list, playerbadge_list) {
      if (!badge_list || badge_list.length === 0) return [];

      const colorMap = { 1: "red", 2: "green", 3: "brown", 4: "blue", 5: "gold" };
      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

      return badge_list.map((badge) => {
        const owned = playerbadge_list
          ? playerbadge_list.find((pb) => pb.badge_fk == badge.badge_pk)
          : null;

        const isNew = owned ? new Date(owned.regdate) >= oneMonthAgo : false;
        const badgeKey = badge.originname2 ? badge.originname2.replace(".svg", "") : "";
        const badgeMobKey = badge.originname ? badge.originname.replace(".svg", "") : "";

        return {
          badge_pk: badge.badge_pk,
          name: badge.title,
          color: colorMap[badge.grade] || "",
          badge: badgeKey,
          badge_mob: badgeMobKey,
          filename: badge.filename,
          filename2: badge.filename2,
          memo: badge.memo,
          new: isNew,
          disabled: !owned,
          regdate: owned ? owned.regdate : null,
        };
      })
      .sort((a, b) => {
        // 보유 배지 앞으로
        if (!a.disabled && b.disabled) return -1;
        if (a.disabled && !b.disabled) return 1;
        return 0;
      });
    },
    // 메인 차트 초기 데이터 세팅
    setChartData(roundData) {
      if (!roundData || !roundData.list || roundData.list.length === 0) return;

      const sorted = [...roundData.list].sort((a, b) =>
        a.regdate_ > b.regdate_ ? 1 : -1,
      );

      // 헤더에 Group 추가
      this.chartsData.data = [["Round", "Group Avg Score", "Avg Score"]];

      sorted.forEach((v) => {
        const groupItem =
          roundData.grouplist.find((g) => g.regdate_ === v.regdate_) || {};
        this.chartsData.data.push([
          v.day,
          parseFloat(groupItem.avg_score) || 0,
          parseFloat(v.avg_score) || 0,
        ]);
      });
    },

    onPopoverChartReady(chart, google) {
      // 팝오버 차트 ready 핸들러 (필요 시 확장)
    },

    get_stats(searchData) {
      this.searchData = { ...this.searchData, ...searchData };
      this.chartsData.saleclubtotalOptions.vAxis.format = this.searchData.format
        .suffix
        ? "#,##0" + this.searchData.format.suffix
        : "#,##0";

      ax.get_stats(this.searchData, (flag, data) => {
        if (flag) {
          this.chartsData.saleclubData = [
            [
              this.$i18n.t("title.common.period"),
              "Group " + this.searchData.chart_title,
              this.searchData.chart_title,
            ],
          ];

          const sortedList = [...data.list].sort().reverse();
          sortedList.forEach((v) => {
            const groupItem =
              data.grouplist.find((item) => item.regdate_ == v.regdate_) || {};
            this.chartsData.saleclubData.push([
              v.day,
              parseFloat(groupItem[this.searchData.field]) || 0,
              parseFloat(v[this.searchData.field]) || 0,
            ]);
          });

          this.$refs["modal-stats-chart"].show();
        } else {
          alert(data.message);
        }
      });
    },

    get_membersummary() {
      ax.get_membersummary((flag, data, code) => {
        if (flag) {
          this.summaryinfo = data.summaryinfo;
          this.recentplayinfo = data.recentplayinfo;
          this.swinginfo = data.swinginfo;
          this.swingdata_yn = data.swinginfo && data.swinginfo.length > 0;
          this.badgecnt = data.badgecnt;
          this.badgeinfo = data.badgeinfo;
          this.badge_list = data.badge_list || [];
          this.playerbadge_list = data.playerbadge_list || [];

          // badgeList 세팅
          this.badgeList = this.buildBadgeList(
            data.badge_list,
            data.playerbadge_list,
          );

          // 메인 차트 데이터 세팅
          if (data.round) {
            this.setChartData(data.round);
          }

          if (this.badgecnt > 0 && this.badgeinfo) {
            this.badgeOpen(
              this.badgeinfo[0].playerbadgeno,
              this.badgeinfo[0].badgename,
              this.badgeinfo[0].badgefilename,
              0,
            );
          }
        } else {
          if (code === "300" || code === 300) {
            this.$notify({
              group: "alert",
              type: "warn",
              text: data.message,
              duration: 5000,
              speed: 1000,
            });
          } else {
            alert(data.message);
          }
          if (code === 401) {
            this.$store.dispatch("logout");
            this.$router.push("/");
          }
        }
      });
    },

    get_list() {
      ax.get_playerpointlist(this.searchData, (flag, data, code = "") => {
        this.playerbadge_list = data.playerbadge_list || [];
        this.player_info = data.player_info || {};
        if (!flag) alert(data.message);
        if (code === 401) {
          this.$store.dispatch("logout");
          this.$router.push("/");
        }
      });
    },

    badgeOpen(playerbadgeno, badgename, badgefilename, badgeseq) {
      this.playerbadgeno = playerbadgeno;
      this.badgename = badgename;
      this.badgefilename = badgefilename;
      this.badgeseq = badgeseq + 1;
      if (this.$refs["modal-badge"]) {
        this.$refs["modal-badge"].show();
        this.badgeMove = true;
      }
    },

    badgeClose(playerbadgeno) {
      ax.badgeUpdateflag(playerbadgeno, (flag, data) => {
        if (flag) {
          this.$refs["modal-badge"].hide();
          this.badgeMove = false;
          setTimeout(() => {
            if (this.badgecnt > 0) {
              for (let i = this.badgeseq; i < this.badgecnt; i++) {
                this.badgeOpen(
                  this.badgeinfo[i].playerbadgeno,
                  this.badgeinfo[i].badgename,
                  this.badgeinfo[i].badgefilename,
                  i,
                );
                this.badgeMove = true;
              }
            }
          }, 1000);
        } else {
          alert(data.message);
        }
      });
    },

    toast_xbadge_info(item) {
      this.$bvToast.show("toast-xbadge-info");
      this.badge_info = item.badge;
    },

    toggle_tr(index) {
      this.view_hide = this.view_hide === index ? null : index;
    },
  },
  created() {
    this.get_membersummary();
    this.get_list();
  },
  computed: {
    newBadgeCount() {
      return this.badgeList.filter((item) => item.new).length;
    },
  },
  watch: {
    "searchData.chart_recent": function (newval, oldval) {
      this.get_stats(this.searchData);
    },
  },
  mixins: [myMixin],
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/my-summary.scss";
</style>
